import { Domain } from "core/types/domain.types";
import { Url } from "core/types/url.types";
import { transformDomain } from "../domain/domain.helpers";

export const transformUrl = (data: any): Url => ({
  id: data?.id,
  status: data?.status as "online" | "pending" | "removed",
  url: data?.url,
  domain: transformDomain(data?.domain),
});
